import { Component, ElementRef, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-menu',
  templateUrl: './landing-menu.component.html',
  styleUrls: ['./landing-menu.component.scss']
})
export class LandingMenuComponent implements OnInit {

  constructor(private eRef: ElementRef) { }

  ngOnInit() {
    this.checkScrollPosition();
  }


  isMenuActive = false;
  isSideMenuActive = false;
  isTransparent: boolean = true;


  @HostListener('mouseover', ['$event.target'])
  onMouseOver(target: HTMLElement) {
    if (target.classList.contains('trigger-menu-system') || target.closest('.system-menu-navigation')) {
      this.isMenuActive = true;
    }
  }


  @HostListener('mouseout', ['$event.relatedTarget'])
  onMouseOut(relatedTarget: HTMLElement) {
    if (!relatedTarget || !relatedTarget.closest('.button-system')) {
      this.isMenuActive = false;
    }
  }

  toggleSideMenu() {
    this.isSideMenuActive = !this.isSideMenuActive;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (this.isSideMenuActive && !this.eRef.nativeElement.contains(event.target)) {
      this.isSideMenuActive = false;
    }
  }


  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkScrollPosition();
  }

  checkScrollPosition() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    this.isTransparent = scrollPosition === 0;
  }


}
